import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { PageListBean } from "../ds/client_ds.js";
import {
  AddressBean,
  BankAccountBean,
  BankAccountSearchCriteria,
  RestBankAccountListRequest,
  RestReadRequest,
} from "../ds/ds.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputCheckbox,
  InputTextbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";
class BankAccountListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
  }

  componentDidUpdate() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };
  deleteOnClick = (e, val, rowData) => {
    if (e.detail == 1) this.props.deleteOnClick(val, rowData);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  opentypeforms = (e) => {
    if (e.detail == 1) this.props.opentypeforms();
  };

  editBankAccount = (e, info) => {
    if (e.detail == 1) this.props.editBankAccount(info);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail == 1) this.props.handleSortingChange(accessor);
  };
  render() {
    let bankAccount_list = this.props.bankAccount_list;
    let bankAccountData = this.props.bankAccountData;

    return (
      <div>
        <div>
          <Row>
            <Col sm="1">
              <FormLabel id="searchBarLabel">BankAccount</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.listFormCodeRef}
                type="text"
                name="code"
                onChange={this.onChange}
                value={bankAccountData.code}
                style={{ "text-transform": "uppercase" }}
                enterKeyEventHandler={this.enterKeyEventHandler}
                isMandatory={true}
              ></InputTextbox>
            </Col>

            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="text-center"
                onClick={(e) => this.opentypeforms(e)}
              >
                Go
              </Button>
            </Col>
          </Row>
        </div>

        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "companyCode")}>
                  CompanyCode{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "companyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "bankAccountNumber")
                  }
                >
                  AccNo{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "bankAccountNumber" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "currencyCode")}
                >
                  Currency{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "currencyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "currentBalanceAmount")
                  }
                >
                  BalAmount{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "currentBalanceAmount" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "isActive")}>
                  Active{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "isActive" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                {/* <th>Remove</th> */}
              </tr>
            </thead>
            <tbody>
              {bankAccount_list.map((Info, index) => (
                <tr key={index}>
                  <td className="td_attribute_width">
                    <Button
                      variant="secondry"
                      className="td_attribute_width"
                      onClick={(e) => this.editBankAccount(e, Info.code)}
                    >
                      {Info.code}
                    </Button>
                  </td>

                  <td> {Info.description}</td>
                  <td>{Info.companyCode}</td>
                  <td>{Info.bankAccountNumber}</td>
                  <td>{Info.currencyCode}</td>
                  <td>{Info.currentBalanceAmount}</td>
                  <td>{Info.isActive}</td>
                  {/* <td className="text-right">
                    <Button
                      variant="secondry"
                      className="hyperLinkText"
                      onClick={(e) => this.deleteOnClick(e, Info.code, Info)}
                    >
                      {<DeleteIcon />}
                    </Button>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </Table>
          {bankAccount_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}

class BankAccountEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();
  }

  componentDidMount() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }
  onChange = (e) => {
    this.props.onChange(e);
  };

  onAddressChange = (e) => {
    this.props.onAddressChange(e);
  };

  onCurrencyCodeChange = (e) => {
    this.props.onCurrencyCodeChange(e);
  };
  currencyCodeEnterKeyEvent = (e) => {
    this.props.currencyCodeEnterKeyEvent(e);
  };
  displayAutoCompleteCurrencyList = (e) => {
    this.props.displayAutoCompleteCurrencyList(e);
  };

  onCityChange = (e) => {
    this.props.onCityChange(e);
  };
  cityEnterKeyEvent = (e) => {
    this.props.cityEnterKeyEvent(e);
  };
  displayAutoCompleteCityList = () => {
    this.props.displayAutoCompleteCityList();
  };

  onStateChange = (e) => {
    this.props.onStateChange(e);
  };
  stateEnterKeyEvent = (e) => {
    this.props.stateEnterKeyEvent(e);
  };
  displayAutoCompleteStateList = () => {
    this.props.displayAutoCompleteStateList();
  };

  onCountryChange = (e) => {
    this.props.onCountryChange(e);
  };
  countryCodeEnterKeyEvent = (e) => {
    this.props.countryCodeEnterKeyEvent(e);
  };
  displayAutoCompleteCountryCodeList = () => {
    this.props.displayAutoCompleteCountryCodeList();
  };

  render() {
    let bankAccountData = this.props.bankAccountData;
    let addressData = this.props.addressData;
    let isDisableFields = this.props.isDisableFields;

    return (
      <div>
        <div>
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Company Code</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="companyCode"
                type="text"
                placeholder="Enter CompanyCode"
                onChange={this.onCheckBoxChange}
                value={bankAccountData.companyCode}
                disabled={true}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Bank Account Type</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                ref={this.codeRef}
                name="code"
                type="text"
                placeholder="Enter BankAccountCode"
                onChange={this.onChange}
                value={bankAccountData.code}
                style={{ "text-transform": "uppercase" }}
                disabled={isDisableFields}
                isMandatory={true}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Bank Account Name</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="description"
                type="text"
                placeholder="Enter Name"
                onChange={this.onChange}
                value={bankAccountData.description}
                style={{ "text-transform": "capitalize" }}
                isMandatory={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Bank Account No</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="bankAccountNumber"
                type="text"
                placeholder="Enter Acc No"
                onChange={this.onChange}
                value={bankAccountData.bankAccountNumber}
                style={{ "text-transform": "capitalize" }}
                isMandatory={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Currency</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onCurrencyCodeChange}
                name="currencyCode"
                value={bankAccountData.currencyCode}
                lookupRequired={true}
                lookupHandler={this.props.currencyLookupHandler}
                enterKeyEventHandler={this.currencyCodeEnterKeyEvent}
                autoCompleteListData={
                  this.props.currencyCodePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteCurrencyList}
                showAutoCompleteList={
                  this.props.showAutoCompleteCurrencyCodeList
                }
                isMandatory={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Current Cheque No</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="currentCheckNumber"
                type="text"
                placeholder="Enter Check No"
                onChange={this.onChange}
                value={bankAccountData.currentCheckNumber}
                style={{ "text-transform": "capitalize" }}
                disabled={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Current Balance Amount</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="currentBalanceAmount"
                type="text"
                placeholder="Enter Current Balance Amount"
                onChange={this.onChange}
                value={bankAccountData.currentBalanceAmount}
                style={{ "text-transform": "capitalize" }}
                disabled={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Active</FormLabel>
            </Col>
            <Col sm="1">
              {" "}
              <InputCheckbox
                type="checkbox"
                name="isActive"
                onChange={this.onChange}
                checked={bankAccountData.isActive}
              />
            </Col>
          </Row>
        </div>
        <br />
        <div>
          <Row>
            <Col sm="2">
              <FormLabel className="address">Address</FormLabel>
            </Col>
          </Row>
          <hr class="row_border"></hr>
          <Row>
            <Col sm="1">
              <FormLabel>Address1</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="address1"
                type="text"
                placeholder="Enter Address1"
                onChange={this.onAddressChange}
                value={addressData.address1}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Country</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                onChange={this.onCountryChange}
                name="country"
                value={addressData.country}
                lookupRequired={true}
                lookupHandler={this.props.countryLookupHandler}
                enterKeyEventHandler={this.countryCodeEnterKeyEvent}
                autoCompleteListData={
                  this.props.countryCodePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteCountryCodeList
                }
                showAutoCompleteList={
                  this.props.showAutoCompleteCountryCodeList
                }
              />
            </Col>
            <Col sm="1">
              <FormLabel>Phone#2</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="phone2"
                type="text"
                placeholder="Enter Phone2"
                onChange={this.onAddressChange}
                value={addressData.phone2}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>Address2</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="address2"
                type="text"
                placeholder="Enter Address2"
                onChange={this.onAddressChange}
                value={addressData.address2}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Zip</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="zip"
                type="text"
                placeholder="Enter Zip"
                onChange={this.onAddressChange}
                value={addressData.zip}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Mobile#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="mobilePhone"
                type="text"
                placeholder="Enter MobileNo"
                onChange={this.onAddressChange}
                value={addressData.mobilePhone}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>City</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                onChange={this.onCityChange}
                name="city"
                value={addressData.city}
                lookupRequired={true}
                lookupHandler={this.props.cityLookupHandler}
                enterKeyEventHandler={this.cityEnterKeyEvent}
                autoCompleteListData={
                  this.props.cityPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteCityList}
                showAutoCompleteList={this.props.showAutoCompleteCityList}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Contact Person</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="contactPerson"
                type="text"
                placeholder="ContactPerson"
                onChange={this.onAddressChange}
                value={addressData.contactPerson}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Email</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="email"
                type="text"
                placeholder="Enter Email"
                onChange={this.onAddressChange}
                value={addressData.email}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>State</FormLabel>
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                onChange={this.onStateChange}
                name="state"
                value={addressData.state}
                lookupRequired={true}
                lookupHandler={this.props.stateLookupHandler}
                enterKeyEventHandler={this.stateEnterKeyEvent}
                autoCompleteListData={
                  this.props.statePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteStateList}
                showAutoCompleteList={this.props.showAutoCompleteStateList}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Phone#1</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="phone1"
                type="text"
                placeholder="Enter PhoneNo1"
                onChange={this.onAddressChange}
                value={addressData.phone1}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Website</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="website"
                type="text"
                placeholder="Enter Website"
                onChange={this.onAddressChange}
                value={addressData.website}
                style={{ "text-transform": "capitalize" }}
              />
            </Col>
          </Row>

          <br />
        </div>
      </div>
    );
  }
}

class BankAccountList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      bankAccount_list: [],
      response: {},
      pageTitle: "Bank Account ",
      bankAccountData: new BankAccountBean(),
      addressData: new AddressBean(),
      pageList: new PageListBean(),
      criteria: new BankAccountSearchCriteria(),
      countries: [],
      cities: [],
      states: [],
      currencies: [],
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      totalCount: 0,
      isBankAccountListFormOpen: true,
      isBankAccountEntryFormOpen: false,
      isShowNodes: false,
      selectedNode: "headerView",
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isShowExitButton: true,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,

      countryLookupHandler: null,
      showAutoCompleteCountryCodeList: true,
      countryCodePageListForAutoCompleteList: new Array(),
      cityLookupHandler: null,
      showAutoCompleteCityList: true,
      cityPageListForAutoCompleteList: new Array(),
      stateLookupHandler: null,
      showAutoCompleteStateList: true,
      statePageListForAutoCompleteList: new Array(),
      currencyLookupHandler: null,
      showAutoCompleteCurrencyCodeList: false,
      currencyCodePageListForAutoCompleteList: new Array(),
      order: "asc",
      sortField: "",
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    const { cache } = appData;
    this.cache = cache;
   
    let bankAccountData = new BankAccountBean();
    bankAccountData.companyCode = this.companyCode;
    this.setState({ bankAccountData: bankAccountData });
    this.loadAttributecache();
    this.initLookupHandlers();
    this.loadPage(1);
    this.cleardata();
  }
  loadAttributecache = () => {
    const attribute_cache = { ...this.cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    this.state.countries = [];
    let countries = attribute_cache.countries;
    if(!isEmptyArray(countries))
    countries.map((countryCode) => {
      this.state.countries.push(countryCode);
    });
    this.state.states = [];
    let states = attribute_cache.states;
    if(!isEmptyArray(states))
    states.map((stateCode) => {
      this.state.states.push(stateCode);
    });

    this.state.cities = [];
    let cities = attribute_cache.cities;
    if(!isEmptyArray(cities))
    cities.map((cityCode) => {
      this.state.cities.push(cityCode);
    });

    this.state.currencies = [];
    let currencies = attribute_cache.currencies;
    if(!isEmptyArray(currencies))
    currencies.map((currency) => {
      this.state.currencies.push(currency);
    });
  };
  moduleCaption = "Bank Account";

  initLookupHandlers = () => {
    let cityLookupHandler = new GenericAttributeLookupHandler(
      this.state.cities,
      "City"
    );
    this.setState({ cityLookupHandler: cityLookupHandler });
    let stateLookupHandler = new GenericAttributeLookupHandler(
      this.state.states,
      "State"
    );
    this.setState({ stateLookupHandler: stateLookupHandler });

    let countryLookupHandler = new GenericAttributeLookupHandler(
      this.state.countries,
      "Country"
    );
    this.setState({ countryLookupHandler: countryLookupHandler });
    let currencyLookupHandler = new GenericAttributeLookupHandler(
      this.state.currencies,
      "Currency"
    );
    this.setState({ currencyLookupHandler: currencyLookupHandler });
  };

  cleardata = () => {
    let bankAccountData = new BankAccountBean();
    bankAccountData.companyCode = this.companyCode;
    let addressData = new AddressBean();
    addressData.companyCode = this.companyCode;
    this.setState({
      bankAccountData: bankAccountData,
      addressData: addressData,
    });
  };

  saveBankAccountResponse = (response) => {
    this.handleresponse(response.data);
    this.loadPage(1);
    this.cleardata();
    this.closeBankAccountEntryForm();
  };

  validateBankAccount = (bankAccountData) => {
    let isBankAccountData = false;
    let err_list = [];
    let errorMessage = "";
    if (bankAccountData == null) {
      let errMsg = "Enter All Fields ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(bankAccountData.description)) {
        let errMsg = "BankAccount Name is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(bankAccountData.code)) {
        let errMsg = "BankAccount Code is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(bankAccountData.currencyCode)) {
        let errMsg = "Currency Code is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isBankAccountData = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isBankAccountData = true;
      this.setState({ isShowAlert: false });
    }
    return isBankAccountData;
  };

  saveBankAccount = () => {
    let bankAccountData = this.state.bankAccountData;
    let addressData = this.state.addressData;
    bankAccountData.address = addressData;
    let isValidLine = false;
    isValidLine = this.validateBankAccount(bankAccountData);
    if (isValidLine) {
      if (bankAccountData.isFetched == true) {
        if (SecurityAccessManager.BankAccountMaintenanceEdit_IsAccessible()) {
          MasterService.updateBankAccount(
            bankAccountData,
            this.saveBankAccountResponse,
            this.errorCallBack
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      } else {
        if (SecurityAccessManager.BankAccountMaintenanceCreate_IsAccessible()) {
          MasterService.createBankAccount(
            bankAccountData,
            this.saveBankAccountResponse,
            this.errorCallBack
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
  };

  editBankAccountResponse = (response) => {
    if (response.data != null) {
      if (response.data.bankAccount != null) {
        let bankAccountData = response.data.bankAccount;
        if (bankAccountData.address != null) {
          let address = bankAccountData.address;
          this.setState({
            addressData: address,
          });
        }
        this.setState({
          bankAccountData: bankAccountData,
        });
        this.disable();
      }
      this.openBankAccountEntryForm();
    }
  };

  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  editBankAccount = (code) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = code;
    if (SecurityAccessManager.BankAccountMaintenanceView_IsAccessible()) {
      MasterService.readBankAccount(
        readrestInput,
        this.editBankAccountResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  onChange = (e) => {
    let bankAccountData = this.state.bankAccountData;
    bankAccountData[e.target.name] = e.target.value;
    this.setState({
      bankAccountData: bankAccountData,
    });
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.opentypeforms();
    }, 200);
  };
  opentypeforms = () => {
    let bankAccountData = this.state.bankAccountData;
    this.editBankAccount(bankAccountData.code);
  };
  deleteOnClick = (val, rowData) => {
    //
  };

  onAddressChange = (e) => {
    let addressData = this.state.addressData;
    addressData[e.target.name] = e.target.value;
    this.setState({ addressData: addressData });
  };

  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };

  save = () => {
    this.saveBankAccount();
  };

  back = () => {
    this.cleardata();
    this.clearError();
    this.hideAlertCallBack(false);
    this.closeBankAccountEntryForm();
    this.componentDidMount();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  openBankAccountEntryForm = () => {
    this.setState({
      isBankAccountListFormOpen: false,
      isBankAccountEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowNodes: false,
      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
    });
    this.hideAlertCallBack();
  };

  closeBankAccountEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isBankAccountListFormOpen: true,
      isBankAccountEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isShowNodes: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
    });
  };

  moduleExit = () => {
    this.props.onModuleExit();
  };

  loadBankAccountResponse = (response) => {
    if (response.data != null && response.data.bankAccountPageList != null) {
      let bankAccounts = new Array();
      if (!isEmptyArray(response.data.bankAccountPageList.bankAccounts)) {
        bankAccounts = response.data.bankAccountPageList.bankAccounts;
        bankAccounts.map((Info) => {
          if (Info.isActive == true) {
            Info.isActive = "True";
          } else {
            Info.isActive = "False";
          }
        });
      }
      let pageList = this.state.pageList;
      pageList.totalCount = response.data.bankAccountPageList.totalCount;
      pageList.currentPage = response.data.bankAccountPageList.currentPage;
      pageList.pageSize = response.data.bankAccountPageList.pageSize;
      this.setState({
        bankAccount_list: bankAccounts,
        pageList: pageList,
      });
    }
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };

  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };

  loadPage = (pageNumber) => {
    let criteria = new BankAccountSearchCriteria();
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadBankAccountPage(pageInput, criteria);
  };

  loadBankAccountPage = (pageList, criteria) => {
    let requestInput = new RestBankAccountListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    this.state.pageList = pageList;
    if (SecurityAccessManager.BankAccountMaintenanceView_IsAccessible()) {
      MasterService.getBankAccountPageList(
        requestInput,
        this.loadBankAccountResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };

  onCountryChange = (e) => {
    let country = e.target.value;
    this.state.showAutoCompleteCountryCodeList = true;
    let addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
    if (isEmpty(country)) {
      this.state.showAutoCompleteCountryCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
      let addressData = this.state.addressData;
      addressData.country = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        addressData: addressData,
        countryCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && country !== "") {
      this.readcountryCodeBySearchString(country);
    }
    if (e.target.name == "country") {
      addressData["country"] = e.target.value;
      let country_List = this.state.countries;
      country_List.map((country) => {
        if (country.code == e.target.value) {
          addressData["country"] = country.code;
          this.state.showAutoCompleteCountryCodeList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ addressData: addressData });
  };
  readcountryCodeBySearchString(searchString) {
    let countryData = this.state.countries;
    let simpleAutoCompleteList = new Array();
    if (countryData.length > 0 && countryData != null) {
      countryData.map((countryDatas) => {
        let simpleItemBean = {
          code: countryDatas.code,
          description: countryDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecountryLists) =>
        simpleAutoCompletecountryLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      countryCodePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  countryCodeEnterKeyEvent = (e) => {
    let addressData = this.state.addressData;
    addressData["country"] = e.target.value;
    let country_List = this.state.countries;
    let countryBean = null;
    country_List.map((country) => {
      if (country.code == e.target.value) {
        countryBean = country;
      }
    });
    if (!isEmpty(countryBean)) {
      let addressData = this.state.addressData;
      addressData.country = countryBean.code;

      this.setState({
        addressData: addressData,
        countryCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCountryCodeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCountryCodeList: showAutoCompleteList });
  };

  onCityChange = (e) => {
    let city = e.target.value;
    this.state.showAutoCompleteCityList = true;
    let temp_addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteCityList;
    if (isEmpty(city)) {
      this.state.showAutoCompleteCityList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCityList;
      let temp_addressData = this.state.addressData;
      temp_addressData.city = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        addressData: temp_addressData,
        cityPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && city !== "") {
      this.readcityBySearchString(city);
    }
    if (e.target.name == "city") {
      temp_addressData["city"] = e.target.value;
      let city_List = this.state.cities;
      city_List.map((city) => {
        if (city.code == e.target.value) {
          temp_addressData["city"] = city.code;
          this.state.showAutoCompleteCityList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCityList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ addressData: temp_addressData });
  };

  readcityBySearchString(searchString) {
    let cityData = this.state.cities;
    let simpleAutoCompleteList = new Array();
    if (cityData.length > 0 && cityData != null) {
      cityData.map((cityDatas) => {
        let simpleItemBean = {
          code: cityDatas.code,
          description: cityDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecityLists) =>
        simpleAutoCompletecityLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ cityPageListForAutoCompleteList: filteredSuggestions });
  }

  cityEnterKeyEvent = (e) => {
    let temp_addressData = this.state.addressData;
    temp_addressData["city"] = e.target.value;
    let city_List = this.state.cities;
    let cityBean = null;
    city_List.map((city) => {
      if (city.code == e.target.value) {
        cityBean = city;
      }
    });
    if (!isEmpty(cityBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.city = cityBean.code;

      this.setState({
        addressData: temp_addressData,
        cityPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCityList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCityList: showAutoCompleteList });
  };

  onStateChange = (e) => {
    let state = e.target.value;
    this.state.showAutoCompleteStateList = true;
    let temp_addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteStateList;
    if (isEmpty(state)) {
      this.state.showAutoCompleteStateList = false;
      let showAutoCompleteList = this.state.showAutoCompleteStateList;
      let temp_addressData = this.state.addressData;
      temp_addressData.state = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        addressData: temp_addressData,
        statePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && state !== "") {
      this.readstateBySearchString(state);
    }
    if (e.target.name == "state") {
      temp_addressData["state"] = e.target.value;
      let state_List = this.state.states;
      state_List.map((state) => {
        if (state.code == e.target.value) {
          temp_addressData["state"] = state.code;
          this.state.showAutoCompleteStateList = false;
          let showAutoCompleteList = this.state.showAutoCompleteStateList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ addressData: temp_addressData });
  };

  readstateBySearchString(searchString) {
    let stateData = this.state.states;
    let simpleAutoCompleteList = new Array();
    if (stateData.length > 0 && stateData != null) {
      stateData.map((stateDatas) => {
        let simpleItemBean = {
          code: stateDatas.code,
          description: stateDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletestateLists) =>
        simpleAutoCompletestateLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ statePageListForAutoCompleteList: filteredSuggestions });
  }
  stateEnterKeyEvent = (e) => {
    let temp_addressData = this.state.addressData;
    temp_addressData["state"] = e.target.value;
    let state_List = this.state.states;
    let stateBean = null;
    state_List.map((state) => {
      if (state.code == e.target.value) {
        stateBean = state;
      }
    });
    if (!isEmpty(stateBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.state = stateBean.code;
      this.setState({
        addressData: temp_addressData,
        statePageListForAutoCompleteList: new Array(),
      });
    }
  };

  displayAutoCompleteStateList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteStateList: showAutoCompleteList });
  };

  onCurrencyCodeChange = (e) => {
    let currencyCode = e.target.value;
    this.state.showAutoCompleteCurrencyCodeList = true;
    let temp_data = this.state.bankAccountData;
    let showAutoCompleteList = this.state.showAutoCompleteCurrencyCodeList;
    if (isEmpty(currencyCode)) {
      this.state.showAutoCompleteCurrencyCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCurrencyCodeList;
      let soLine = this.state.bankAccountData;
      soLine.currencyCode = "";
      soLine.fromCurrencyName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        bankAccountData: soLine,
        currencyCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && currencyCode !== "") {
      this.readCurrencyCodeBySearchString(currencyCode);
    }
    if (e.target.name == "currencyCode") {
      temp_data["currencyCode"] = e.target.value;
      let currencyCode_List = this.state.currencies;
      currencyCode_List.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_data["currencyCode"] = pdtType.code;
          this.state.showAutoCompleteCurrencyCodeList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteCurrencyCodeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ bankAccountData: temp_data });
  };
  readCurrencyCodeBySearchString(searchString) {
    let currencyCodeData = this.state.currencies;
    let simpleAutoCompleteList = new Array();
    if (currencyCodeData.length > 0 && currencyCodeData != null) {
      currencyCodeData.map((currencyCodeDatas) => {
        let simpleItemBean = {
          code: currencyCodeDatas.code,
          description: currencyCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecurrencyCodeLists) =>
        simpleAutoCompletecurrencyCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      currencyCodePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  currencyCodeEnterKeyEvent = (e) => {
    let temp_data = this.state.bankAccountData;
    temp_data["currencyCode"] = e.target.value;
    let CurrencyCode_List = this.state.currencies;
    let CurrencyCodeBean = null;
    CurrencyCode_List.map((pdtType) => {
      if (pdtType.code == e.target.value) {
        CurrencyCodeBean = pdtType;
      }
    });
    if (!isEmpty(CurrencyCodeBean)) {
      let temp_data = this.state.bankAccountData;
      temp_data.currencyCode = CurrencyCodeBean.code;
      temp_data.fromCurrencyName = CurrencyCodeBean.description;
      this.setState({
        bankAccountData: temp_data,
        currencyCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCurrencyList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCurrencyCodeList: showAutoCompleteList });
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.bankAccount_list;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ bankAccount_list: sorted });
    }
  };
  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />

        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}
        {this.state.isBankAccountListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
          />
        )}

        {!this.state.isBankAccountListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
          />
        )}
        {this.state.isBankAccountListFormOpen && (
          <BankAccountListForm
            {...this.state}
            onChange={this.onChange}
            editBankAccount={this.editBankAccount}
            opentypeforms={this.opentypeforms}
            enterKeyEventHandler={this.enterKeyEventHandler}
            deleteOnClick={this.deleteOnClick}
            handleSortingChange={this.handleSortingChange}
          />
        )}

        {this.state.isBankAccountEntryFormOpen && (
          <BankAccountEntryForm
            {...this.state}
            onChange={this.onChange}
            onAddressChange={this.onAddressChange}
            onCurrencyCodeChange={this.onCurrencyCodeChange}
            currencyCodeEnterKeyEvent={this.currencyCodeEnterKeyEvent}
            displayAutoCompleteCurrencyList={
              this.displayAutoCompleteCurrencyList
            }
            onCityChange={this.onCityChange}
            cityEnterKeyEvent={this.cityEnterKeyEvent}
            displayAutoCompleteCityList={this.displayAutoCompleteCityList}
            onCountryChange={this.onCountryChange}
            countryCodeEnterKeyEvent={this.countryCodeEnterKeyEvent}
            displayAutoCompleteCountryCodeList={
              this.displayAutoCompleteCountryCodeList
            }
            onStateChange={this.onStateChange}
            stateEnterKeyEvent={this.stateEnterKeyEvent}
            displayAutoCompleteStateList={this.displayAutoCompleteStateList}
          />
        )}
      </div>
    );
  }
}

function BankAccountAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="app">
        <BankAccountList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default BankAccountAttributeModule;
